export default __webpack_public_path__ + "static/media/ardmore (1).875cf75b.png";